import React, { useState } from 'react';
import {
  ChevronDoubleDownIcon,
  ChevronDoubleUpIcon,
} from '@heroicons/react/outline';

interface SectionPanelProps {
  title: string;
  children?: React.ReactNode;
  /** Rendered beside the collapse chevron, e.g. a visibility switch. */
  headerAction?: React.ReactNode;
  defaultOpen?: boolean;
}

export const FieldSection = ({
  left,
  right,
}: {
  left: React.ReactElement;
  right: React.ReactElement;
}) => {
  return (
    <div className="my-2 flex flex-row justify-between items-top shadow-sm py-2">
      <div>{left}</div>
      <div>{right}</div>
    </div>
  );
};

const SectionPanel = ({
  title,
  children,
  headerAction,
  defaultOpen = true,
}: SectionPanelProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-gray-300 rounded-lg mb-4 bg-white shadow-sm">
      <div
        className="flex justify-between items-center p-4 bg-gray-100 cursor-pointer rounded-t-lg"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-lg font-semibold">{title}</h3>
        <div className="flex items-center gap-3">
          {headerAction ? (
            // Interacting with the switch must not collapse the panel.
            <div
              onClick={(event) => event.stopPropagation()}
              onKeyDown={(event) => event.stopPropagation()}
              role="presentation"
            >
              {headerAction}
            </div>
          ) : null}
          {isOpen ? (
            <ChevronDoubleUpIcon
              style={{ width: '20px' }}
              className="text-gray-500"
            />
          ) : (
            <ChevronDoubleDownIcon
              style={{ width: '20px' }}
              className="text-gray-500"
            />
          )}
        </div>
      </div>
      {isOpen && <div className="p-4">{children}</div>}
    </div>
  );
};

export default SectionPanel;
